import { Box, Card, Grid, Typography } from "@common-ui/ui";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getOrg } from "../../services";
import { getOrgCustomer } from "../../services/orgCustomer";

const CustomerCard = (props) => {
  const [customer, setCustomer] = useState(null);
  const workEvent = useSelector((state) => state.workEvent[props.eventId]);

  const getCustomer = async () => {
    try {
      if (workEvent?.for_customer) {
        const externalCustomer = await getOrgCustomer(
          props?.orgId,
          workEvent?.for_customer
        );
        setCustomer(externalCustomer);
      } else {
        const internalCustomer = await getOrg(workEvent.for_customer);
        setCustomer(internalCustomer);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workEvent]);

  return (
    <Card sx={{ mb: "24px" }}>
      <Box sx={{ p: 2, pb: 2 }}>
        <Grid container spacing={0.5} direction="column">
          <Grid item display="flex" justify="center" alignItems="center">
            <Typography color="textPrimary" variant="h4" sx={{ mt: 2 }}>
              Prepared for
            </Typography>
          </Grid>
          <Grid item md={6} xs={6}>
            <Typography variant="body2" sx={{ mt: 2 }}>
              {customer?.name}
            </Typography>
            <Typography variant="body2">
              {customer?.street_address?.address_line_1}
            </Typography>
            <Typography variant="body2">
              {customer?.street_address?.address_line_2}
            </Typography>
            <Typography variant="body2">
              {customer?.street_address?.city}
              {customer?.street_address?.country_or_region}
              {customer?.street_address?.state_or_province}
              {customer?.street_address?.postal_code}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default CustomerCard;
